module.exports = __webpack_public_path__ + "img/trigana.d258ecfd.svg";